export default "__VITE_ASSET__Qs3vW5Bm__"